import { Link } from "react-router-dom";
import { useLang } from "@/lang";

export default function NotFound() {
    const { lang } = useLang();
    const t = {
        en: { h1: "Page not found", body: "The page you are looking for doesn't exist or has moved.", cta: "Back to home" },
        es: { h1: "Página no encontrada", body: "La página que buscas no existe o se ha movido.", cta: "Volver al inicio" },
    }[lang];
    return (
        <section
            className="flex min-h-[70svh] flex-col items-center justify-center gap-6 bg-paper px-6 text-center"
            data-testid="notfound-page"
        >
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-sky-text">404</p>
            <h1 className="text-4xl font-light tracking-tight text-ink sm:text-5xl">{t.h1}</h1>
            <p className="max-w-md text-base leading-relaxed text-ink-soft">{t.body}</p>
            <Link
                to="/"
                data-testid="notfound-home-link"
                className="rounded-full bg-ink px-8 py-4 text-sm font-semibold uppercase tracking-[0.08em] text-paper transition-colors hover:bg-sky-deep"
            >
                {t.cta}
            </Link>
        </section>
    );
}
